import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table, Form, Button } from "react-bootstrap";
import { FaEdit, FaTrash, FaPlus, FaEye, FaSync } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import "./WorkAllotmentList.css";
import api from "../services/api";

const WorkAllotmentList = () => {
  const [search, setSearch] = useState("");
  const navigate = useNavigate();
  const [workerNames, setWorkerNames] = useState([]);

  // Dummy data for work allotments
  const [workAllotments, setWorkAllotments] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      // setLoading(true);
      // setError(null);
      // Fetch suppliers
      const workerResponse = await api.post("/job_worker_list.php", {});
      if (workerResponse.data.head.code === 200) {
        setWorkerNames(workerResponse.data.body);
      }

      const response = await api.post("/work_allotment_list.php", {});

      if (response.data.head.code === 200) {


        setWorkAllotments(response.data.body);
        console.log("==================", response.data.body);
      } else {

      }
    } catch (err) {
      console.error("Error fetching products:", err);

    } finally {

    }
  };


  // Delete handler
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this work allotment?")) {
      setWorkAllotments(workAllotments.filter((item) => item.id !== id));
    }

    try {
      const response = await api.post("/work_allotment_delete.php", { id });

      if (response.data.head.code === 200) {
        // Remove from local state
        setWorkAllotments(workAllotments.filter((p) => p.id !== id));
        alert("deleted successfully!");
      } else {
        alert("Failed to delete: " + response.data.head.msg);
      }
    } catch (err) {
      console.error("Error deleting:", err);
      alert("Failed to delete. Please try again.");
    }
  };

  // Filter work allotments based on search
  const filteredAllotments = workAllotments.filter((item) => {
    console.log("search is ", search);
    if (!search) return true;
    // const query = search.toLowerCase();
    // return (
    //   item.name.toLowerCase().includes(query) ||
    //   item.product.toLowerCase().includes(query) ||
    //   item.status.toLowerCase().includes(query) ||
    //   item.date.includes(query)
    // );
    return String(item.worker_id) === String(search);
  });

  return (
    <Container fluid className="outer-container my-3">
      <h2 className="text-center mb-3">Work Allotment Management</h2>

      {/* Search and Add Button Section */}
      <Row className="mb-3 align-items-center">
        <Col xs={12} md={6} lg={4} className="mb-2 mb-md-0">
          {/* <Form.Control
            placeholder="Search by worker, product, or status"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Escape') setSearch("");
            }}
          /> */}
          <Form.Select
            name="worker_name"
            // onChange={handleFormChange}
            onChange={(e) => setSearch(e.target.value)}
          // isInvalid={!!errors.worker_name}
          >
            <option value="">Select Worker</option>
            {workerNames.map((worker) => (
              <option key={worker.id} value={worker.id}>
                {worker.name}
              </option>
            ))}
          </Form.Select>
        </Col>

        <Col xs={12} md={6} lg={8} className="d-flex justify-content-md-end gap-2">
          <Button
            variant="primary"
            onClick={() => navigate("/addwork")}
            className="d-inline-flex align-items-center"
          >
            <FaPlus className="me-2" /> Add Work Allotment
          </Button>

          {/* <Button
            variant="success"
            onClick={() => navigate("/addworkreturn")}
            className="d-inline-flex align-items-center"
          >
            <FaPlus className="me-2" /> Add Return Entry
          </Button> */}
        </Col>
      </Row>

      {/* Summary Section */}
      <Row className="mt-4 mb-4">
        <Col md={4}>
          <div
            // className="summary-card bg-primary text-white p-3 rounded"
            className="summary-card text-white p-3 rounded"
            style={{ backgroundColor: "#800000" }}   // maroon
          >
            <h6>Total Allotted</h6>
            <h3>
              {/* {workAllotments.reduce(
                (sum, item) => sum + Number(String(item.allot_qty).replace(/,/g, "")),
                0
              ).toLocaleString()
              } */}
              {filteredAllotments
                .reduce(
                  (sum, item) =>
                    sum + Number(String(item.allot_qty).replace(/,/g, "")),
                  0
                )
                .toLocaleString()}
            </h3>
          </div>
        </Col>
        <Col md={4}>
          <div className="summary-card bg-success text-white p-3 rounded">
            <h6>Total Returned</h6>
            <h3>
              {/* {workAllotments.reduce(
                (sum, item) => sum + Number(String(item.return_qty).replace(/,/g, "")),
                0
              ).toLocaleString()
              } */}
              {filteredAllotments
                .reduce(
                  (sum, item) =>
                    sum + Number(String(item.return_qty).replace(/,/g, "")),
                  0
                )
                .toLocaleString()}
            </h3>
          </div>
        </Col>
        <Col md={4}>
          <div className="summary-card bg-warning text-dark p-3 rounded">
            <h6>Total Balance</h6>
            <h3>
              {/* {workAllotments.reduce(
                (sum, item) => sum + Number(String(item.balance_qty).replace(/,/g, "")),
                0
              ).toLocaleString()
              } */}
              {filteredAllotments
                .reduce(
                  (sum, item) =>
                    sum + Number(String(item.balance_qty).replace(/,/g, "")),
                  0
                )
                .toLocaleString()}
            </h3>
          </div>
        </Col>
      </Row>

      {/* Table Section */}
      <div className="table-responsive">
        <Table bordered responsive className="table-striped workallotment-table">
          <thead className="table-dark">
            <tr>
              <th>S.No</th>
              <th>Date</th>
              <th>Worker Name</th>
              <th>Raw Prod.</th>
              {/* <th>Return Prod.</th> */}
              <th>Allot.Qty</th>
              <th>Retn.Qty</th>
              <th>Bal.Qty</th>
              <th>Amount</th>
              <th>Return</th>
              {/* <th>Status</th> */}
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredAllotments.map((item, index) => (
              <tr key={item.id}>
                <td>{index + 1}</td>
                <td>{item.allot_date}</td>
                <td>{item.worker_name}</td>
                <td>{item.raw_name}</td>
                {/* <td>{item.finished_name}</td> */}
                <td className="text-end">{item.allot_qty.toLocaleString()}</td>
                <td className="text-end">{item.return_qty.toLocaleString()}</td>
                <td className="text-end fw-bold">{item.balance_qty.toLocaleString()}</td>
                <td className="text-end">{item.amount_total_kg}</td>
                <div className="action-icons">
                  <Link
                    to={`/workallotmentreturn/${item.id}`}
                    className="me-2"
                    title="View Details"
                  >
                    <FaSync className="view-icon" />
                  </Link>
                </div>
                {/* <td>
                  <span className={`badge bg-${item.status === 'Completed' ? 'success' : 
                    item.status === 'In Progress' ? 'warning' : 'danger'}`}>
                    {item.status}
                  </span>
                </td> */}
                <td>
                  <div className="action-icons">
                    <Link
                      to={`/workallotmentview/${item.id}`}
                      className="me-2"
                      title="View Details"
                    >
                      <FaEye className="view-icon" />
                    </Link>
                    {/* <Link
                      to={`/editworkallotment/${item.id}`}
                      className="me-2"
                      title="Edit"
                    >
                      <FaEdit className="edit-icon" />
                    </Link> */}
                    {/* <FaTrash
                      className="delete-icon"
                      title="Delete"
                      onClick={() => handleDelete(item.id)}
                      style={{ cursor: 'pointer' }}
                    /> */}
                    <FaTrash
                      className={`delete-icon ${item.return_qty > 0 ? 'disabled' : ''}`}
                      title={item.return_qty > 0 ? 'Cannot delete' : 'Delete'}
                      onClick={item.return_qty > 0 ? null : () => handleDelete(item.id)}
                      style={{
                        color: item.return_qty > 0 ? 'grey' : 'red',
                        cursor: item.return_qty > 0 ? 'not-allowed' : 'pointer',
                        opacity: item.return_qty > 0 ? 1 : 1
                      }}
                    />

                  </div>
                </td>
              </tr>
            ))}
            {filteredAllotments.length === 0 && (
              <tr>
                <td colSpan="9" className="text-center text-muted py-3">
                  {search ? "No work allotments found matching your search" : "No work allotments found"}
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

    </Container>
  );
};

export default WorkAllotmentList;